//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import triplepl from "~/components/loading-placeholders/triple-pl.vue";
import subNavSelection from "~/components/header-item-selection";
import BannerTypeProduct from "~/components/content-elements/banner-type-product";
import productBox from "~/components/product-boxes/goument-style";

export default {
  data() {
    return {
      newItem: [
        { title: "Black tea", type: "black_tea" },
        { title: "Green tea", type: "green_tea" },
        { title: "White tea ", type: "white_tea" },
        { title: "Oolong tea", type: "oolong_tea" },
      ],
      currentType: "black_tea",
    };
  },
  components: {
    productBox,
    BannerTypeProduct,
    subNavSelection,
    triplepl,
  },
  mounted() {
    this.currentType =
      typeof this.$route.query.type != "undefined" &&
      this.$route.query.type != "infusion" &&
      this.$route.query.type != "green_tea"
        ? this.$route.query.type
        : "black_tea";

    this.$router.push({
      path: "/our-products/our-teas/tea-ranges/t-series-designer-gourmet-tea/rare-teas",
      query: { type: this.currentType },
    });
    this.$store.dispatch("tea-products/getTSeriesGourmet"),
      this.$store.dispatch("tea-range/getProductByRange", {
        rangeName: "dilmah_t_series_designer_gourmet",
      });
  },
  computed: {
    pageData() {
      if (this.$store.state["tea-products"].tSeriesGourmet != null) {
        return Object.assign(
          this.$store.state["tea-products"].tSeriesGourmet
            .very_special_rare_teas,
          {
            links: this.$store.state["tea-products"].tSeriesGourmet.links,
          }
        );
      }
    },
    productData() {
      if (this.$store.state["tea-range"].productByRange != null) {
        return this.$store.state["tea-range"].productByRange.rareTeas;
      } else {
        return null;
      }
    },
  },
  watch: {
    pageData() {
      this.$nuxt.$loading.finish();
    },
    $route(to) {
      if (this.$route.query.type != "infutions") {
        this.currentType = to.query.type;
      }
    },
  },
};
